import { RenderLayerNodes, RenderLayerNode } from './render-layer-node.type';

export const sortRenderLayerNodes = (renderLayerNodes: RenderLayerNodes): RenderLayerNode[] => {
	const sortedEntries = Array.from(renderLayerNodes.entries()).sort(([, a], [, b]) => {
		if (a.layer !== b.layer) {
			return a.layer - b.layer;
		}
		return a.priority - b.priority;
	});

	return sortedEntries.map(([, node]) => node);
};
